export default __webpack_public_path__ + "navigation-examples-route-deserialize-thumbnail-480-0aa0cb48732a784997435380065d8bb9.png";